/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface AdminapiPingResponse {
  message?: string;
}

export enum EnumsAdContactStatus {
  AD_CONTACT_STATUS_UNSPECIFIED = "AD_CONTACT_STATUS_UNSPECIFIED",
  AD_CONTACT_STATUS_TRUE = "AD_CONTACT_STATUS_TRUE",
  AD_CONTACT_STATUS_FALSE = "AD_CONTACT_STATUS_FALSE",
}

export enum EnumsCarrer {
  CARRER_UNSPECIFIED = "CARRER_UNSPECIFIED",
  CARRER_OTHER_CARRER = "CARRER_OTHER_CARRER",
  CARRER_DOCOMO = "CARRER_DOCOMO",
  CARRER_AU = "CARRER_AU",
  CARRER_SOFTBANK = "CARRER_SOFTBANK",
}

/**
* - CLUSTER_MARKET_MTEEN: マーケ区分
 - CLUSTER_TENS_M10S: クラスタ区分
 - CLUSTER_GENDER_MALE: 男女区分（サーベイ独自）
*/
export enum EnumsCluster {
  CLUSTER_UNSPECIFIED = "CLUSTER_UNSPECIFIED",
  CLUSTER_MARKET_MTEEN = "CLUSTER_MARKET_MTEEN",
  CLUSTERMARKETM1 = "CLUSTER_MARKET_M1",
  CLUSTERMARKETM2 = "CLUSTER_MARKET_M2",
  CLUSTERMARKETM3 = "CLUSTER_MARKET_M3",
  CLUSTER_MARKET_FTEEN = "CLUSTER_MARKET_FTEEN",
  CLUSTERMARKETF1 = "CLUSTER_MARKET_F1",
  CLUSTERMARKETF2 = "CLUSTER_MARKET_F2",
  CLUSTERMARKETF3 = "CLUSTER_MARKET_F3",
  CLUSTERTENSM10S = "CLUSTER_TENS_M10S",
  CLUSTERTENSM20S = "CLUSTER_TENS_M20S",
  CLUSTERTENSM30S = "CLUSTER_TENS_M30S",
  CLUSTERTENSM40S = "CLUSTER_TENS_M40S",
  CLUSTERTENSM50S = "CLUSTER_TENS_M50S",
  CLUSTERTENSF10S = "CLUSTER_TENS_F10S",
  CLUSTERTENSF20S = "CLUSTER_TENS_F20S",
  CLUSTERTENSF30S = "CLUSTER_TENS_F30S",
  CLUSTERTENSF40S = "CLUSTER_TENS_F40S",
  CLUSTERTENSF50S = "CLUSTER_TENS_F50S",
  CLUSTER_GENDER_MALE = "CLUSTER_GENDER_MALE",
  CLUSTER_GENDER_FEMALE = "CLUSTER_GENDER_FEMALE",
}

export enum EnumsClusterType {
  CLUSTER_TYPE_UNSPECIFIED = "CLUSTER_TYPE_UNSPECIFIED",
  CLUSTER_TYPE_MARKET_CLUSTER = "CLUSTER_TYPE_MARKET_CLUSTER",
  CLUSTER_TYPE_TENS_CLUSTER = "CLUSTER_TYPE_TENS_CLUSTER",
  CLUSTER_TYPE_GENDER = "CLUSTER_TYPE_GENDER",
}

export enum EnumsDevice {
  DEVICE_UNSPECIFIED = "DEVICE_UNSPECIFIED",
  DEVICE_OTHER = "DEVICE_OTHER",
  DEVICE_SP = "DEVICE_SP",
  DEVICE_TV = "DEVICE_TV",
  DEVICE_PC = "DEVICE_PC",
}

export enum EnumsOS {
  OS_UNSPECIFIED = "OS_UNSPECIFIED",
  OS_OTHER_OS = "OS_OTHER_OS",
  OS_IOS = "OS_IOS",
  OS_ANDROID = "OS_ANDROID",
}

export enum EnumsQuestionType {
  QUESTION_TYPE_UNSPECIFIED = "QUESTION_TYPE_UNSPECIFIED",
  QUESTION_TYPE_SINGLE_ANSWER = "QUESTION_TYPE_SINGLE_ANSWER",
  QUESTION_TYPE_MULTI_ANSWER = "QUESTION_TYPE_MULTI_ANSWER",
}

export enum EnumsSurveySortBy {
  SORT_BY_UNSPECIFIED = "SORT_BY_UNSPECIFIED",
  SORT_BY_ID = "SORT_BY_ID",
  SORT_BY_NAME = "SORT_BY_NAME",
  SORT_BY_PROGRESS = "SORT_BY_PROGRESS",
  SORT_BY_CREATED_AT = "SORT_BY_CREATED_AT",
}

export enum EnumsSurveyStatus {
  SURVEY_STATUS_UNSPECIFIED = "SURVEY_STATUS_UNSPECIFIED",
  SURVEY_STATUS_ON = "SURVEY_STATUS_ON",
  SURVEY_STATUS_OFF = "SURVEY_STATUS_OFF",
}

export enum EnumsSurveyType {
  SURVEY_TYPE_UNSPECIFIED = "SURVEY_TYPE_UNSPECIFIED",
  SURVEY_TYPE_AD_CONTACT = "SURVEY_TYPE_AD_CONTACT",
  SURVEY_TYPE_PRE_AD = "SURVEY_TYPE_PRE_AD",
}

export interface ProtobufAny {
  "@type"?: string;
}

export interface RpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export interface ServerBulkCreateSurveysRequest {
  requests?: ServerCreateSurveyRequest[];
}

export interface ServerBulkCreateSurveysResponse {
  surveys?: TypesSurveyFullInfo[];
}

export interface ServerCreateSurveyRequest {
  name?: string;
  status?: EnumsSurveyStatus;
  type?: EnumsSurveyType;
  memo?: string;
  questions?: TypesQuestion[];

  /** @format int64 */
  targetCollectionNum?: number;
  targetRatio?: TypesTargetRatio;
  recency?: TypesRecency;
  reset?: TypesReset;

  /** @format int64 */
  surveyStartAt?: string;

  /** @format int64 */
  surveyEndAt?: string;
}

export interface ServerCreateSurveyResponse {
  survey?: TypesSurveyFullInfo;
}

export type ServerDeleteSurveyResponse = object;

export interface ServerFindSurveyFilter {
  name?: string;
  status?: EnumsSurveyStatus;

  /** @format int64 */
  progressMinPercent?: number;

  /** @format int64 */
  progressMaxPercent?: number;
  ids?: string[];
}

export interface ServerFindSurveySort {
  sortBy?: EnumsSurveySortBy;
  desc?: boolean;
}

export interface ServerFindSurveysResponse {
  surveys?: TypesSurveyPartialInfo[];

  /** @format int64 */
  total?: string;
}

export interface ServerGetImageUploadURLResponse {
  name?: string;
  url?: string;
}

export interface ServerGetReportResponse {
  /** @format int64 */
  surveyId?: string;
  url?: string;
}

export interface ServerGetSurveyResponse {
  survey?: TypesSurveyFullInfo;
}

export interface ServerPagination {
  /** @format int64 */
  page?: number;

  /** @format int64 */
  perPage?: number;
}

export interface ServerUpdateSurveyRequest {
  /** @format int64 */
  id?: string;
  name?: string;
  status?: EnumsSurveyStatus;
  type?: EnumsSurveyType;
  memo?: string;
  questions?: TypesQuestion[];

  /** @format int64 */
  targetCollectionNum?: number;
  targetRatio?: TypesTargetRatio;
  recency?: TypesRecency;
  reset?: TypesReset;

  /** @format int64 */
  surveyStartAt?: string;

  /** @format int64 */
  surveyEndAt?: string;
}

export interface ServerUpdateSurveyResponse {
  survey?: TypesSurveyFullInfo;
}

export interface ServerUpdateSurveyStatusResponse {
  survey?: TypesSurveyPartialInfo;
}

export interface TypesAdContactStatusRatio {
  isActive?: boolean;

  /** @format int64 */
  adContactStatusTrueRatio?: number;

  /** @format int64 */
  adContactStatusFalseRatio?: number;
}

export interface TypesAnswer {
  /** @format int64 */
  id?: string;

  /** @format int64 */
  order?: number;
  text?: string;
  fixOrder?: boolean;
  exclusive?: boolean;

  /** @format int64 */
  lift?: string;
}

export interface TypesCarrerRatio {
  isActive?: boolean;

  /** @format int64 */
  careerOtherRatio?: number;

  /** @format int64 */
  careerDocomoRatio?: number;

  /** @format int64 */
  careerAuRatio?: number;

  /** @format int64 */
  careerSoftbankRatio?: number;
}

export interface TypesClusterRatio {
  isActive?: boolean;

  /** @format int64 */
  clusterMarketMteenRatio?: number;

  /** @format int64 */
  clusterMarketM1Ratio?: number;

  /** @format int64 */
  clusterMarketM2Ratio?: number;

  /** @format int64 */
  clusterMarketM3Ratio?: number;

  /** @format int64 */
  clusterMarketFteenRatio?: number;

  /** @format int64 */
  clusterMarketF1Ratio?: number;

  /** @format int64 */
  clusterMarketF2Ratio?: number;

  /** @format int64 */
  clusterMarketF3Ratio?: number;

  /** @format int64 */
  clusterTensM10sRatio?: number;

  /** @format int64 */
  clusterTensM20sRatio?: number;

  /** @format int64 */
  clusterTensM30sRatio?: number;

  /** @format int64 */
  clusterTensM40sRatio?: number;

  /** @format int64 */
  clusterTensM50sRatio?: number;

  /** @format int64 */
  clusterTensF10sRatio?: number;

  /** @format int64 */
  clusterTensF20sRatio?: number;

  /** @format int64 */
  clusterTensF30sRatio?: number;

  /** @format int64 */
  clusterTensF40sRatio?: number;

  /** @format int64 */
  clusterTensF50sRatio?: number;

  /** @format int64 */
  clusterGenderMaleRatio?: number;

  /** @format int64 */
  clusterGenderFemaleRatio?: number;
}

export interface TypesDeviceRatio {
  isActive?: boolean;

  /** @format int64 */
  deviceOtherRatio?: number;

  /** @format int64 */
  deviceSpRatio?: number;

  /** @format int64 */
  deviceTvRatio?: number;

  /** @format int64 */
  devicePcRatio?: number;
}

export interface TypesOSRatio {
  isActive?: boolean;

  /** @format int64 */
  osOtherRatio?: number;

  /** @format int64 */
  osIosRatio?: number;

  /** @format int64 */
  osAndroidRatio?: number;
}

export interface TypesProgress {
  /** @format int64 */
  collectedNum?: number;
  target?: TypesTarget;
}

export interface TypesQuestion {
  /** @format int64 */
  id?: string;

  /** @format int64 */
  order?: number;
  type?: EnumsQuestionType;
  text?: string;
  random?: boolean;
  imageUrl?: string;
  kind?: string;
  answers?: TypesAnswer[];
}

export interface TypesRecency {
  isActive?: boolean;

  /** @format int64 */
  days?: number;
}

export interface TypesReset {
  isActive?: boolean;

  /** @format int64 */
  days?: number;

  /** @format int64 */
  periodTargetCollectionNum?: number;
}

export interface TypesSurveyFullInfo {
  /** @format int64 */
  id?: string;
  name?: string;
  status?: EnumsSurveyStatus;
  type?: EnumsSurveyType;
  memo?: string;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
  questions?: TypesQuestion[];

  /** @format int64 */
  targetCollectionNum?: number;
  targetRatio?: TypesTargetRatio;
  progress?: TypesProgress[];
  recency?: TypesRecency;
  reset?: TypesReset;

  /** @format int64 */
  surveyStartAt?: string;

  /** @format int64 */
  surveyEndAt?: string;
}

export interface TypesSurveyPartialInfo {
  /** @format int64 */
  id?: string;
  name?: string;
  status?: EnumsSurveyStatus;
  type?: EnumsSurveyType;

  /** @format int64 */
  targetCollectionNum?: number;

  /** @format int64 */
  collectedNum?: number;

  /** @format date-time */
  createdAt?: string;

  /** @format date-time */
  updatedAt?: string;
}

export interface TypesTarget {
  adContactStatus?: EnumsAdContactStatus;

  /**
   * - CLUSTER_MARKET_MTEEN: マーケ区分
   *  - CLUSTER_TENS_M10S: クラスタ区分
   *  - CLUSTER_GENDER_MALE: 男女区分（サーベイ独自）
   */
  targetCluster?: EnumsCluster;
  targetCarrer?: EnumsCarrer;
  targetDevice?: EnumsDevice;
  targetOs?: EnumsOS;
}

export interface TypesTargetRatio {
  clusterType?: EnumsClusterType;
  clusterRatio?: TypesClusterRatio;
  contactRatio?: TypesAdContactStatusRatio;
  deviceRatio?: TypesDeviceRatio;
  carrerRatio?: TypesCarrerRatio;
  osRatio?: TypesOSRatio;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, "body" | "method" | "query" | "path">;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  private encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  private addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  private addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => "undefined" !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string") ? JSON.stringify(input) : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  private mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  private createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`, {
      ...requestParams,
      headers: {
        ...(type && type !== ContentType.FormData ? { "Content-Type": type } : {}),
        ...(requestParams.headers || {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : void 0,
      body: typeof body === "undefined" || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title survey/services/adminapipb/survey-admin-api.proto
 * @version version not set
 */
export class Api<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiPing
     * @summary Ping
     * @request GET:/api/ping
     */
    surveyAdminApiPing: (params: RequestParams = {}) =>
      this.request<AdminapiPingResponse, RpcStatus>({
        path: `/api/ping`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiGetImageUploadUrl
     * @summary GetImageUploadURL 画像アップロード用のGCSURLの取得(管理画面向け)
     * @request GET:/api/v1/image-upload-url
     */
    surveyAdminApiGetImageUploadUrl: (params: RequestParams = {}) =>
      this.request<ServerGetImageUploadURLResponse, RpcStatus>({
        path: `/api/v1/image-upload-url`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiGetReport
     * @summary GetReport レポートを取得する（管理画面向け）
     * @request GET:/api/v1/report/{surveyId}
     */
    surveyAdminApiGetReport: (surveyId: string, params: RequestParams = {}) =>
      this.request<ServerGetReportResponse, RpcStatus>({
        path: `/api/v1/report/${surveyId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiCreateSurvey
     * @summary CreateSurvey サーベイの作成(管理画面向け)
     * @request POST:/api/v1/survey
     */
    surveyAdminApiCreateSurvey: (body: ServerCreateSurveyRequest, params: RequestParams = {}) =>
      this.request<ServerCreateSurveyResponse, RpcStatus>({
        path: `/api/v1/survey`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiUpdateSurvey
     * @summary UpdateSurvey サーベイの更新(管理画面向け)
     * @request PATCH:/api/v1/survey
     */
    surveyAdminApiUpdateSurvey: (body: ServerUpdateSurveyRequest, params: RequestParams = {}) =>
      this.request<ServerUpdateSurveyResponse, RpcStatus>({
        path: `/api/v1/survey`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiGetSurvey
     * @summary GetSurvey サーベイの詳細情報を取得(管理画面向け)
     * @request GET:/api/v1/survey/{id}
     */
    surveyAdminApiGetSurvey: (id: string, params: RequestParams = {}) =>
      this.request<ServerGetSurveyResponse, RpcStatus>({
        path: `/api/v1/survey/${id}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiDeleteSurvey
     * @summary DeleteSurvey サーベイを削除(管理画面向け)
     * @request DELETE:/api/v1/survey/{id}
     */
    surveyAdminApiDeleteSurvey: (id: string, params: RequestParams = {}) =>
      this.request<ServerDeleteSurveyResponse, RpcStatus>({
        path: `/api/v1/survey/${id}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiUpdateSurveyStatus
     * @summary UpdateSurveyStatus サーベイの配信状態(SurveyStatus)を更新(管理画面向け)
     * @request PATCH:/api/v1/survey/{id}/status
     */
    surveyAdminApiUpdateSurveyStatus: (id: string, body: { status?: EnumsSurveyStatus }, params: RequestParams = {}) =>
      this.request<ServerUpdateSurveyStatusResponse, RpcStatus>({
        path: `/api/v1/survey/${id}/status`,
        method: "PATCH",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiFindSurveys
     * @summary FindSurveys サーベイの一覧の取得(管理画面向け)
     * @request GET:/api/v1/surveys
     */
    surveyAdminApiFindSurveys: (
      query?: {
        "filter.name"?: string;
        "filter.status"?: "SURVEY_STATUS_UNSPECIFIED" | "SURVEY_STATUS_ON" | "SURVEY_STATUS_OFF";
        "filter.progressMinPercent"?: number;
        "filter.progressMaxPercent"?: number;
        "filter.ids"?: string[];
        "sort.sortBy"?:
          | "SORT_BY_UNSPECIFIED"
          | "SORT_BY_ID"
          | "SORT_BY_NAME"
          | "SORT_BY_PROGRESS"
          | "SORT_BY_CREATED_AT";
        "sort.desc"?: boolean;
        "pagination.page"?: number;
        "pagination.perPage"?: number;
      },
      params: RequestParams = {},
    ) =>
      this.request<ServerFindSurveysResponse, RpcStatus>({
        path: `/api/v1/surveys`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags SurveyAdminApi
     * @name SurveyAdminApiBulkCreateSurveys
     * @summary BulkCreateSurveys サーベイのバルク作成(管理画面向け)
     * @request POST:/api/v1/surveys/bulk
     */
    surveyAdminApiBulkCreateSurveys: (body: ServerBulkCreateSurveysRequest, params: RequestParams = {}) =>
      this.request<ServerBulkCreateSurveysResponse, RpcStatus>({
        path: `/api/v1/surveys/bulk`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),
  };
}
